# Route: /admin/tenants
# Platform admin: all tenants overview

page-admin-tenant-list:
  type: Page
  archetype: list
  meta:
    title: $t.admin.tenants.meta_title
    auth: required
  data:
    tenants:
      model: TenantResponse[]
      # /api/platform/tenants is gated by .WithRequiresFilter("status", "name").
      # Default to Active tenants on mount; platform admins can change the filter
      # via the table header. SystemAdmin bypass also exists but normal operators
      # must carry a filter.
      filter:
        status: Active
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - tenant-list-header
    - tenant-list-table

# ── Page header ──────────────────────────────────────────────────────────────

tenant-list-header:
  type: PageHeader
  title: $t.admin.tenants.title
  # F79 — actions: list form (not the action_label/action_route shorthand) so the
  # create action can carry return_context; Cancel / on_success on the create
  # screen returns to this list.
  actions:
    - label: $t.admin.tenants.create
      route: /admin/tenants/create
      return_context: origin_only

# ── Tenant table ─────────────────────────────────────────────────────────────

tenant-list-table:
  type: Table
  bind:
    rows: tenants
  a11y:
    label: $t.admin.tenants.table_label
  # M1 list-filter adoption (DEC-090) — opt-in client-side quick-filter over the
  # loaded rows: case-insensitive substring across name / id / status + native
  # clear. Complements the server-side status filter (WithRequiresFilter).
  filter:
    fields: [name, id, status]
    placeholder: $t.common.quick_filter
  columns:
    - key: name
      label: $t.admin.tenants.col_name
      width: 2fr
    # TenantResponse serialises its id as JSON `id` (JsonPropertyName("id")),
    # so the row field is `id`, not `tenantId`.
    - key: id
      label: $t.admin.tenants.col_id
      width: 1fr
    - key: status
      label: $t.admin.tenants.col_status
      width: 1fr
    - key: createdAt
      label: $t.admin.tenants.col_created
      width: 1fr
  row_action:
    type: navigate
    # Route placeholder stays :tenantId to match the /admin/tenants/:tenantId
    # detail route; the value comes from the row's `id` field.
    route: /admin/tenants/:tenantId
    params:
      tenantId: $row.id
  empty: tenant-list-empty

tenant-list-empty:
  type: EmptyState
  content: $t.admin.tenants.empty
  body: $t.admin.tenants.empty_body
